// extracted by css-extract-rspack-plugin
export default {"trigger":"ZQqhUG_otMQpQNS4","icon":"o74OsenBbNAmL4q4","chevron":"iXrxiMNkR1M0Qqye","children":"Mi8c3nfL4HhYybPr","label":"WJK9L7qapCQSQwvr"};